import { render, staticRenderFns } from "./input_form.vue?vue&type=template&id=6754ea06&scoped=true"
import script from "./input_form.vue?vue&type=script&lang=js"
export * from "./input_form.vue?vue&type=script&lang=js"
import style0 from "./input_form.vue?vue&type=style&index=0&id=6754ea06&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6754ea06",
  null
  
)

export default component.exports